export default __webpack_public_path__ + "static/media/Banner.1d800c6b.svg";